module.exports = __webpack_public_path__ + "img/half.b726f79c.svg";